'use strict';

var App = require('app');
var AppState = require('app_state');
var BaseDeviceController = require('components/devices/controllers/base_device_controller');
var HomeController = require('components/home/home_controller');
var I18N = require('utils/i18n');
var RankingView = require('components/devices/views/tools/ranking/ranking_view');

var RankingController = BaseDeviceController.extend({
    initialize: function () {},

    show: function () {
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                AppState.layout.breadcrumbs.reset();
                App.trigger('sidebar:default', 'ranking');

                App.requestDone('ranking:rules', function (rules) {
                    if (App.errIfUndefined(rules, I18N.TR('Die Regeln konnten nicht geladen werden.'))) {
                        return;
                    }

                    var rankingView = new RankingView({
                        rules: rules,
                        controller: self,
                    });
                    App.showContentView(rankingView);
                });
            },
        });
    },
});

module.exports = RankingController;
